import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=c1026fac&scoped=true"
import script from "./PersonalSettings.vue?vue&type=script&lang=js"
export * from "./PersonalSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=c1026fac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1026fac",
  null
  
)

export default component.exports